export default "__VITE_ASSET__Bkk2a_Xw__"